
    const original = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"40\" viewBox=\"0 0 40 40\"><defs><style>.cls-1,.cls-2{fill:#855CD6;}.cls-1{opacity:0.15;}.cls-3{fill:#fff;}</style></defs><title>01_Dial Elements</title><circle class=\"cls-1\" cx=\"20\" cy=\"20\" r=\"20\"/><circle class=\"cls-2\" cx=\"20\" cy=\"20\" r=\"16\"/><path class=\"cls-3\" d=\"M20.53,12.44l5,5A.74.74,0,0,1,25,18.68H22.37L21,26.86a1.08,1.08,0,0,1-2.13,0l-1.34-8.18H15a.74.74,0,0,1-.52-1.26l5-5A.77.77,0,0,1,20.53,12.44Z\"/></svg>\n";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original.replace(/#855cd6/gi, Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
